import * as Matter from 'matter-js'
import lib from './lib.js';

const matterAnimation = () => {

    if(document.getElementById('wpbody-content')) {
        return;
    }

    var Example = Example || {};

    Example.mixed = function() {
        var Engine = Matter.Engine,
            Render = Matter.Render,
            Runner = Matter.Runner,
            Composites = Matter.Composites,
            Common = Matter.Common,
            MouseConstraint = Matter.MouseConstraint,
            Mouse = Matter.Mouse,
            Composite = Matter.Composite,
            Bodies = Matter.Bodies;

        // create enginex
        var engine = Engine.create(),
            world = engine.world;

        // create renderer
        var render = Render.create({
            element: lib.qs('#canvas'),
            engine: engine,
            options: {
                width: window.innerWidth,
                height: 830,
                // color
                background: 'rgba(0, 0, 0, 0)',
                showAngleIndicator: false,
                wireframes: false

            }
        });

        Render.run(render);

        // create runner
        var runner = Runner.create();
        Runner.run(runner, engine);

        // add bodies
        var stack = Composites.stack(20, 20, 10, 5, 0, 0, function(x, y) {
            var sides = Math.round(Common.random(1, 8));

            // round the edges of some bodies
            var chamfer = null;
            if (sides > 2 && Common.random() > 0.7) {
                chamfer = {
                    radius: 20
                };
            }
            var images = ['HI/profile.svg', 'HI/search.svg','HI/cog.svg', 'HI/directional.svg', 'HI/navigation.svg', 'HI/strategy.svg'];
            //    var images = ['HI/cog.svg'];
            var randomImage = images[Math.floor(Common.random(0, images.length))];

            switch (Math.round(Common.random(0, 1))) {
            case 0:
                if (Common.random() < 0.5) {
                    var rectWidth = 1.5 * Common.random(50, 120);
                    var rectHeight = 1.5 * Common.random(25, 120);
                    return Bodies.rectangle(x, y, rectWidth, rectHeight, {
                        render: {
                            sprite: {
                                texture: '/wp-content/themes/pw-associates/assets/img/' + randomImage,
                                xScale: rectWidth / 100,
                                yScale: rectHeight / 100
                            }
                        },
                        lineWidth: 0
                    });
                } else {
                    var rectWidth = 2 * Common.random(80, 120);
                    var rectHeight = 2 * Common.random(80, 120);
                    return Bodies.rectangle(x, y, rectWidth, rectHeight, {
                        render: {
                            sprite: {
                                texture: '/wp-content/themes/pw-associates/assets/img/' + randomImage,
                                xScale: rectWidth / 100,
                                yScale: rectHeight / 100
                            }
                        },
                        lineWidth: 0
                    });
                }
            case 1:
                var polyRadius = 2 * Common.random(50, 120);
                return Bodies.polygon(x, y, sides, polyRadius, {
                    render: {
                        sprite: {
                            texture: '/wp-content/themes/pw-associates/assets/img/' + randomImage,
                            xScale: (polyRadius * 2) / 100,
                            yScale: (polyRadius * 2) / 100
                        }
                    },
                    lineWidth: 0
                });
            }
        });

        Composite.add(world, stack);

        Composite.add(world, [
            // bottom wall: centered horizontally, placed so its bottom edge aligns with canvas bottom
            Bodies.rectangle(window.innerWidth / 2, 820, window.innerWidth, 4, { isStatic: true }),

            // right wall: positioned so its right edge aligns with canvas right edge
            Bodies.rectangle(window.innerWidth + 5, 415, 10, 830, { isStatic: true }),

            // left wall: positioned so its left edge aligns with canvas left edge
            Bodies.rectangle(-10, 415, 10, 830, { isStatic: true })
        ]);

        // add mouse control
        var mouse = Mouse.create(render.canvas),
            mouseConstraint = MouseConstraint.create(engine, {
                mouse: mouse,
                constraint: {
                    stiffness: 0.2,
                    render: {
                        visible: false
                    }
                }
            });

        Composite.add(world, mouseConstraint);

        // keep the mouse in sync with rendering
        render.mouse = mouse;

        // fit the render viewport to the scene
        Render.lookAt(render, {
            min: { x: 0, y: 0 },
            max: { x: window.innerWidth, y: 800 }
        });

        // context for MatterTools.Demo
        return {
            engine: engine,
            runner: runner,
            render: render,
            canvas: render.canvas,
            stop: function() {
                Matter.Render.stop(render);
                Matter.Runner.stop(runner);
            }
        };
    };

    Example.mixed.title = 'Mixed Shapes';
    Example.mixed.for = '>=0.14.2';

    Example.mixed();

    // if (typeof module !== 'undefined') {
    //     module.exports = Example.mixed;
    // }

};

export default matterAnimation